import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  getOtop,
  addToCart,
  removeFromCart
} from './actions'
import './style.css'
import Paper from 'material-ui/Paper';
import {GridList, GridTile} from 'material-ui/GridList';
import {CardTitle} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Subheader from 'material-ui/Subheader';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

import SessionHeader from '../../components/SessionHeader/SessionHeader'
import language from '../../config/language'

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    paddingBottom: 5
  },
  gridList: {
    overflowY: 'auto',
  },
};

 class OtopContainer extends Component {
   state = {
     search: '',
     open: false,
     filterId: 0
   }
  componentDidMount() {
    this.props.getOtop()
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.props.lang) {
      this.props.getOtop()
    }
  }
  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };
  renderContent() {
    let data = this.props.data;
    if (this.state.filterId !== 0 && this.state.search !== '') {
      data = data.filter(value => value.category_id === this.state.filterId && value.title_th.includes(this.state.search))
    } else if (this.state.filterId !== 0) {
      data = data.filter(value => value.category_id === this.state.filterId)
    } else if (this.state.search !== '') {
      data = data.filter(value => value.title_th.includes(this.state.search))
    }
    const getCart = (id) => {
      const qty = this.props.cart.find(value => value.id === id)
      return qty ? qty.qty : 0
    }
    if (this.props.error && !this.props.data.length) {
      return  <p>{language[this.props.lang].system.incorrect}</p>
    }
    if (this.props.data.length) {
      const {
        title,
        loading,
        addTocart,
        qty
      } = language[this.props.lang].otop.cart
      return (
        <div className='otopCartList'>
          <TextField hintText="Search" fullWidth={true} style={{ top: -10 }} onChange={(event, newValue) => {
            this.setState({ search: newValue });
          }} />
          <GridList
            cellHeight={200}
            style={{
              overflow: 'hidden',
              // justifyContent: 'center',
              // paddingBottom: 10
            }}
            padding={10}
          >
          {data.map((tile) => (
              <div
                style={{
                  overflow: 'hidden',
                  backgroundColor: '#ffffff',
                  height: '100%',
                  height: '100%',
                  display: "flex",
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}>
                <div className='wrapImage'>
                  {/* <img
                    src={tile.picture_url}
                    className='otopImage'
                  /> */}
                  {/* <p className='textOverlay'>{tile.title_th}</p> */}
                  <GridTile
                    style={{ padding: 0, borderRadius: 3 }}
                    containerElement={<Link to={'/details/popularOtop/'+tile.id} />}
                    key={tile.img}
                    titleStyle={{
                      height: 48
                    }}
                    titleBackground="linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
                    // titleBackground="linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(255, 255, 255, 0)"
                    title={
                      <div style={{ paddingTop: 10, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingRight: 15 }}>
                        <span
                          style={{
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            display:'inline-block',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {tile.title_th}
                        </span>
                        <span>{tile.price} THB</span>
                      </div>
                    }
                  >
                    <img src={tile.picture_url} />
                  </GridTile>
                </div>
                <div className='wrapButton'>
                  <div style={{ width: 50 }}>
                    <RaisedButton fullWidth label="-" primary onClick={() => this.props.removeFromCart(tile.id)} />
                  </div>
                  <h3>{getCart(tile.id)}</h3>
                  <div style={{ width: 50 }}>
                    <RaisedButton fullWidth label="+" primary onClick={() => this.props.addToCart(tile.id)} />
                  </div>
                </div>
              </div>
            ))}
          </GridList>
        </div>
      )
    }
  }
  render() {
    const {
      list,
      ok,
      requestOder,
      noteHaveCart,
      noteHaveCartMsg
    } = language[this.props.lang].otop
    const {
      title,
      loading
    } = list
    
    const {
      filter,
      textAllFillter
    } = language[this.props.lang]
    const actions = [
      <FlatButton
        label={ok}
        primary={true}
        onClick={this.handleClose}
      />,
    ];
    return (
      <Paper zDepth={1} style={{
        padding: 10,
        marginTop: 10,
        paddingTop: 1
      }}>
      <div> 
        <div style={{  paddingTop: 5 }}>     
         <SessionHeader
            hiddenSeemore
            // dropdown
            title={title}
            titleColor='#f44336'
            // textSeemore={filter}
            // textAllFillter={textAllFillter}
            // list={this.props.category.map(value => ({
            //   ...value,
            //   title: value['title_'+this.props.lang]
            // }))}
            // onClick={filterId => this.setState({ filterId })}
          />
        </div>
          {
            this.props.loading
            ? <p>{loading}</p>
            : this.renderContent()
          }

          <RaisedButton
            label={requestOder}
            primary={true}
            fullWidth
            style={{ marginTop: 50 }}
            onClick={() => {
              if (this.props.cart.length === 0) {
                this.handleOpen()
              }
            }}
            containerElement={
              this.props.cart.length > 0
              ? <Link to={'/contact'} />
              : <div />
            }
          />
        </div>
        <Dialog
          title={noteHaveCart}
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
        >
        {noteHaveCartMsg}
        </Dialog>
      </Paper>
    )
  }
}

const mapStateToProps = ({ lang, category, ...state }) => ({
  data: state.otop.list[lang].data,
  loading: state.otop.list.loading,
  error: state.otop.list.error,
  cart: state.otop.cart.cart,
  lang,
  category
})
export default connect(mapStateToProps, {
  getOtop,
  addToCart,
  removeFromCart
}
)(OtopContainer)




// WEBPACK FOOTER //
// ./src/containers/Otop/OtopContainer.js